/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiContainerAction, ApiService } from '@Model';
import type { HttpActions, ListInfo, ListRequest, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of ContainerActionContentController.
 */
export class ContainerActionContentRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /orders/{rootObjectId}/container_actions/{subObjectId}/content:prefill
     */
    public createPrefilled(subObjectId: string, rootObjectId: string): Promise<Result<ApiService>> {
        return this.http.post<Result<ApiService>, undefined>(`/orders/${rootObjectId}/container_actions/${subObjectId}/content:prefill`, undefined);
    }

    /**
     * Calls PATCH /orders/{rootObjectId}/container_actions/{subObjectId}/content
     */
    public addLinkedObject(id: string, subObjectId: string, rootObjectId: string): Promise<Result<ApiContainerAction>> {
        const query = new URLSearchParams();
        query.set('id', `${id}`);

        return this.http.patch<Result<ApiContainerAction>, undefined>(`/orders/${rootObjectId}/container_actions/${subObjectId}/content`, undefined, query);
    }

    /**
     * Calls POST /orders/{rootObjectId}/container_actions/{subObjectId}/content/linkable:query
     */
    public getLinkableObjects(listRequest: ListRequest, showAll: boolean, subObjectId: string, rootObjectId: string): Promise<Result<ListInfo<ApiService>>> {
        const query = new URLSearchParams();
        query.set('showAll', `${showAll}`);

        return this.http.post<Result<ListInfo<ApiService>>, ListRequest>(`/orders/${rootObjectId}/container_actions/${subObjectId}/content/linkable:query`, listRequest, query);
    }

    /**
     * Calls DELETE /orders/{rootObjectId}/container_actions/{subObjectId}/content
     */
    public deleteLinkedObject(id: string, subObjectId: string, rootObjectId: string): Promise<Result<ApiContainerAction>> {
        const query = new URLSearchParams();
        query.set('id', `${id}`);

        return this.http.delete<Result<ApiContainerAction>>(`/orders/${rootObjectId}/container_actions/${subObjectId}/content`, query);
    }
}
